var map = {
	"./square/ac.svg": 1725,
	"./square/ad.svg": 1726,
	"./square/ae.svg": 1727,
	"./square/af.svg": 1728,
	"./square/ag.svg": 1729,
	"./square/ai.svg": 1730,
	"./square/al.svg": 1731,
	"./square/am.svg": 1732,
	"./square/ao.svg": 1733,
	"./square/aq.svg": 1734,
	"./square/ar.svg": 1735,
	"./square/as.svg": 1736,
	"./square/at.svg": 1737,
	"./square/au.svg": 1738,
	"./square/aw.svg": 1739,
	"./square/ax.svg": 1740,
	"./square/az.svg": 1741,
	"./square/ba.svg": 1742,
	"./square/bb.svg": 1743,
	"./square/bd.svg": 1744,
	"./square/be.svg": 1745,
	"./square/bf.svg": 1746,
	"./square/bg.svg": 1747,
	"./square/bh.svg": 1748,
	"./square/bi.svg": 1749,
	"./square/bj.svg": 1750,
	"./square/bl.svg": 1751,
	"./square/bm.svg": 1752,
	"./square/bn.svg": 1753,
	"./square/bo.svg": 1754,
	"./square/bq.svg": 1755,
	"./square/br.svg": 1756,
	"./square/bs.svg": 1757,
	"./square/bt.svg": 1758,
	"./square/bv.svg": 1759,
	"./square/bw.svg": 1760,
	"./square/by.svg": 1761,
	"./square/bz.svg": 1762,
	"./square/ca.svg": 1763,
	"./square/cc.svg": 1764,
	"./square/cd.svg": 1765,
	"./square/cefta.svg": 1766,
	"./square/cf.svg": 1767,
	"./square/cg.svg": 1768,
	"./square/ch.svg": 1769,
	"./square/ci.svg": 1770,
	"./square/ck.svg": 1771,
	"./square/cl.svg": 1772,
	"./square/cm.svg": 1773,
	"./square/cn.svg": 1774,
	"./square/co.svg": 1775,
	"./square/cp.svg": 1776,
	"./square/cr.svg": 1777,
	"./square/cu.svg": 1778,
	"./square/cv.svg": 1779,
	"./square/cw.svg": 1780,
	"./square/cx.svg": 1781,
	"./square/cy.svg": 1782,
	"./square/cz.svg": 1783,
	"./square/de.svg": 1784,
	"./square/dg.svg": 1785,
	"./square/dj.svg": 1786,
	"./square/dk.svg": 1787,
	"./square/dm.svg": 1788,
	"./square/do.svg": 1789,
	"./square/dz.svg": 1790,
	"./square/ea.svg": 1791,
	"./square/ec.svg": 1792,
	"./square/ee.svg": 1793,
	"./square/eg.svg": 1794,
	"./square/eh.svg": 1795,
	"./square/er.svg": 1796,
	"./square/es-ct.svg": 1797,
	"./square/es-ga.svg": 1798,
	"./square/es.svg": 1799,
	"./square/et.svg": 1800,
	"./square/eu.svg": 1801,
	"./square/fi.svg": 1802,
	"./square/fj.svg": 1803,
	"./square/fk.svg": 1804,
	"./square/fm.svg": 1805,
	"./square/fo.svg": 1806,
	"./square/fr.svg": 1807,
	"./square/ga.svg": 1808,
	"./square/gb-eng.svg": 1809,
	"./square/gb-nir.svg": 1810,
	"./square/gb-sct.svg": 1811,
	"./square/gb-wls.svg": 1812,
	"./square/gb.svg": 1813,
	"./square/gd.svg": 1814,
	"./square/ge.svg": 1815,
	"./square/gf.svg": 1816,
	"./square/gg.svg": 1817,
	"./square/gh.svg": 1818,
	"./square/gi.svg": 1819,
	"./square/gl.svg": 1820,
	"./square/gm.svg": 1821,
	"./square/gn.svg": 1822,
	"./square/gp.svg": 1823,
	"./square/gq.svg": 1824,
	"./square/gr.svg": 1825,
	"./square/gs.svg": 1826,
	"./square/gt.svg": 1827,
	"./square/gu.svg": 1828,
	"./square/gw.svg": 1829,
	"./square/gy.svg": 1830,
	"./square/hk.svg": 1831,
	"./square/hm.svg": 1832,
	"./square/hn.svg": 1833,
	"./square/hr.svg": 1834,
	"./square/ht.svg": 1835,
	"./square/hu.svg": 1836,
	"./square/ic.svg": 1837,
	"./square/id.svg": 1838,
	"./square/ie.svg": 1839,
	"./square/il.svg": 1840,
	"./square/im.svg": 1841,
	"./square/in.svg": 1842,
	"./square/io.svg": 1843,
	"./square/iq.svg": 1844,
	"./square/ir.svg": 1845,
	"./square/is.svg": 1846,
	"./square/it.svg": 1847,
	"./square/je.svg": 1848,
	"./square/jm.svg": 1849,
	"./square/jo.svg": 1850,
	"./square/jp.svg": 1851,
	"./square/ke.svg": 1852,
	"./square/kg.svg": 1853,
	"./square/kh.svg": 1854,
	"./square/ki.svg": 1855,
	"./square/km.svg": 1856,
	"./square/kn.svg": 1857,
	"./square/kp.svg": 1858,
	"./square/kr.svg": 1859,
	"./square/kw.svg": 1860,
	"./square/ky.svg": 1861,
	"./square/kz.svg": 1862,
	"./square/la.svg": 1863,
	"./square/lb.svg": 1864,
	"./square/lc.svg": 1865,
	"./square/li.svg": 1866,
	"./square/lk.svg": 1867,
	"./square/lr.svg": 1868,
	"./square/ls.svg": 1869,
	"./square/lt.svg": 1870,
	"./square/lu.svg": 1871,
	"./square/lv.svg": 1872,
	"./square/ly.svg": 1873,
	"./square/ma.svg": 1874,
	"./square/mc.svg": 1875,
	"./square/md.svg": 1876,
	"./square/me.svg": 1877,
	"./square/mf.svg": 1878,
	"./square/mg.svg": 1879,
	"./square/mh.svg": 1880,
	"./square/mk.svg": 1881,
	"./square/ml.svg": 1882,
	"./square/mm.svg": 1883,
	"./square/mn.svg": 1884,
	"./square/mo.svg": 1885,
	"./square/mp.svg": 1886,
	"./square/mq.svg": 1887,
	"./square/mr.svg": 1888,
	"./square/ms.svg": 1889,
	"./square/mt.svg": 1890,
	"./square/mu.svg": 1891,
	"./square/mv.svg": 1892,
	"./square/mw.svg": 1893,
	"./square/mx.svg": 1894,
	"./square/my.svg": 1895,
	"./square/mz.svg": 1896,
	"./square/na.svg": 1897,
	"./square/nc.svg": 1898,
	"./square/ne.svg": 1899,
	"./square/nf.svg": 1900,
	"./square/ng.svg": 1901,
	"./square/ni.svg": 1902,
	"./square/nl.svg": 1903,
	"./square/no.svg": 1904,
	"./square/np.svg": 1905,
	"./square/nr.svg": 1906,
	"./square/nu.svg": 1907,
	"./square/nz.svg": 1908,
	"./square/om.svg": 1909,
	"./square/pa.svg": 1910,
	"./square/pe.svg": 1911,
	"./square/pf.svg": 1912,
	"./square/pg.svg": 1913,
	"./square/ph.svg": 1914,
	"./square/pk.svg": 1915,
	"./square/pl.svg": 1916,
	"./square/pm.svg": 1917,
	"./square/pn.svg": 1918,
	"./square/pr.svg": 1919,
	"./square/ps.svg": 1920,
	"./square/pt.svg": 1921,
	"./square/pw.svg": 1922,
	"./square/py.svg": 1923,
	"./square/qa.svg": 1924,
	"./square/re.svg": 1925,
	"./square/ro.svg": 1926,
	"./square/rs.svg": 1927,
	"./square/ru.svg": 1928,
	"./square/rw.svg": 1929,
	"./square/sa.svg": 1930,
	"./square/sb.svg": 1931,
	"./square/sc.svg": 1932,
	"./square/sd.svg": 1933,
	"./square/se.svg": 1934,
	"./square/sg.svg": 1935,
	"./square/sh.svg": 1936,
	"./square/si.svg": 1937,
	"./square/sj.svg": 1938,
	"./square/sk.svg": 1939,
	"./square/sl.svg": 1940,
	"./square/sm.svg": 1941,
	"./square/sn.svg": 1942,
	"./square/so.svg": 1943,
	"./square/sr.svg": 1944,
	"./square/ss.svg": 1945,
	"./square/st.svg": 1946,
	"./square/sv.svg": 1947,
	"./square/sx.svg": 1948,
	"./square/sy.svg": 1949,
	"./square/sz.svg": 1950,
	"./square/ta.svg": 1951,
	"./square/tc.svg": 1952,
	"./square/td.svg": 1953,
	"./square/tf.svg": 1954,
	"./square/tg.svg": 1955,
	"./square/th.svg": 1956,
	"./square/tj.svg": 1957,
	"./square/tk.svg": 1958,
	"./square/tl.svg": 1959,
	"./square/tm.svg": 1960,
	"./square/tn.svg": 1961,
	"./square/to.svg": 1962,
	"./square/tr.svg": 1963,
	"./square/tt.svg": 1964,
	"./square/tv.svg": 1965,
	"./square/tw.svg": 1966,
	"./square/tz.svg": 1967,
	"./square/ua.svg": 1968,
	"./square/ug.svg": 1969,
	"./square/um.svg": 1970,
	"./square/un.svg": 1971,
	"./square/us.svg": 1972,
	"./square/uy.svg": 1973,
	"./square/uz.svg": 1974,
	"./square/va.svg": 1975,
	"./square/vc.svg": 1976,
	"./square/ve.svg": 1977,
	"./square/vg.svg": 1978,
	"./square/vi.svg": 1979,
	"./square/vn.svg": 1980,
	"./square/vu.svg": 1981,
	"./square/wf.svg": 1982,
	"./square/ws.svg": 1983,
	"./square/xk.svg": 1984,
	"./square/xx.svg": 1985,
	"./square/ye.svg": 1986,
	"./square/yt.svg": 1987,
	"./square/za.svg": 1988,
	"./square/zm.svg": 1989,
	"./square/zw.svg": 1990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1724;